import { useEffect, useState } from 'react'
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectInput from '../../../../Core/Fields/SelectInput';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import { useGetTaxcategoryQuery, useGetAllcompanyQuery } from '../../../../store/api/Salestaxes';
import Table from './Table';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
const Tab1 = ({ pageState, setPageState, taxes, compname, handleChange, onInputChange, salestaxId  }) => {
const [selected_item_data, setselected_item_data] = useState([]);
    const [taxoptions, setTaxoptions] = useState([])
    const [companyoptions, setCompanyoptions] = useState([])
    const { data: taxCat, isError, isLoading } = useGetTaxcategoryQuery()
    const { data: companydata } = useGetAllcompanyQuery()

    useEffect(() => {
        if (taxCat?.data?.length) {
            setTaxoptions(taxCat.data)
        }
    }, [taxCat])
    useEffect(() => {
        if (companydata?.data?.length) {
            setCompanyoptions(companydata.data)
        }
    }, [companydata])



    const [selectedCompany, setSelectedCompany] = useState('')

    return (
          <div>
            <div className="px-4 py-4" style={{ background: 'white' }}>

                <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

                    <div className="col-md-12">
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>

                            <div style={{ display: 'flex', gap: '15px', marginBottom: '-10px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='' style={{ fontSize: '16px', fontWeight: '600', marginLeft: '2px' }}>Details</p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                               <div style={{ flex: 1 }}>
                                                <Input
                                                  name='title'
                                                  label="Title"
                                                  value={pageState.title}
                                                  onChange={(e) => handleChange('title', e.target.value)}
                                                  style={{ height: "30px" }}
                                                  readOnly
                                                />
                                              </div>
                                              <div style={{ flex: 1 }}>
                                                <SelectSearch
                                                  list={taxoptions}
                                                  label="Tax Category"
                                                  value={pageState.taxcategory}
                                                  onChange={(val) => handleChange('taxcategory', val)}
                                                  getOptionLabel={(item) => item.name}
                                                  getOptionValue={(item) => item.name}
                                                  placeholder="Tax Category"
                                                />
                              
                                              </div>
                              
                              
                                              <div style={{ flex: 1 }}>
                                                <SelectSearch
                                                  list={companyoptions}
                                                  label="Company"
                                                  value={pageState.company}
                                                  onChange={(val) => handleChange('company', val)}
                                                  getOptionLabel={(item) => item.name}
                                                  getOptionValue={(item) => item.name}
                                                  placeholder="Company"
                                                />
                              
                              
                                              </div>

                                <div style={{ flex: 1 }}>
                                    <label style={{ height: '19px' }}></label>

                                    <Checkbox
                                        id="Default"
                                        label="Default"
                                        checked={true}
                                        value={pageState.default || false}
                                        onChange={(checked) => onInputChange("default", checked)}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={{ height: '19px' }}></label>
                                    <Checkbox
                                        id="Disabled"
                                        label="Disabled"
                                        checked={true}
                                        value={pageState.disabled || false}
                                        onChange={(checked) => onInputChange("disabled", checked)}
                                    />

                                </div>

                            </div>







                        </div>
                    </div>

                </div>


                <div className="mb-3" style={{ display: 'flex', gap: '20px', border: '1px solid #DBDBDB', borderRadius: '5px' }} >

                    <div className="col-md-12">
                        <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='' style={{ fontSize: '16px', fontWeight: '600' }}>Taxes and Charges</p>
                                </div>
                            </div>


<Table taxes={{ value: pageState.taxes, setValue: (v) => setPageState({ ...pageState, taxes: v }) }} compname={pageState.company} />



                        </div>
                    </div>

                </div>

                <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

                    <div className="col-md-12">
                        <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                           <ActivityCard doctype="Sales Taxes and Charges Template" docname={salestaxId} />
                        </div>
                    </div>
                </div>


            </div>
        </div>
    )
}

export default Tab1